<div class="mb-2">
  <app-custom-instructions-form
    [(ngModel)]="customInstruction"
    (ngModelChange)="
      onCustomInstructionChange($event)
    "></app-custom-instructions-form>
</div>

<form class="flex flex-col gap-4" [formGroup]="form">
  <p-floatlabel variant="on">
    <p-select
      id="user-text-type"
      [options]="userTextTypeOptions"
      formControlName="userTextType"
      [fluid]="true"
      appendTo="body" />
    <label for="user-text-style">Desired style</label>
  </p-floatlabel>

  <div class="flex justify-end gap-2">
    <p-button
      label="Cancel"
      [text]="true"
      severity="secondary"
      (click)="handleCancelClick()" />
    <p-button
      label="Ok"
      [outlined]="true"
      severity="primary"
      (click)="handleSaveClick()" />
    <p-button
      label="Generate"
      icon="pi pi-arrow-right"
      iconPos="right"
      [severity]="!isGenerateEnabled ? 'secondary' : 'primary'"
      [disabled]="!isGenerateEnabled"
      [rounded]="true"
      (click)="handleGenerateClick()" />
  </div>
</form>
